<template>
  <v-dialog
    width="500"
    @keydown.esc="closeDialog"
    v-model="showNotification"
    content-class="dialog-send-by-email">
    <v-card>
      <v-card-title>
        <v-flex class="text-xs-right">
          <a href="#" @click.stop.prevent="closeDialog">
            {{ $t('Close') }}
            <v-icon>close</v-icon>
          </a>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-layout
          align-center
          justify-space-between
          column
          fill-height
          wrap
          class="dialog-title"
        >
          <h3 class="modal-subheading">{{ $t('email_me_notification') }}</h3>
          <v-text-field
            type="mail"
            v-bind:label="$t('enter_your_email')"
            v-bind:placeholder="$t('example_email')"
            class="email-notify-me"
            v-model="emailNotification"
            :error-messages="emailErrorMessage"
          ></v-text-field>
          <v-btn class="v-btn v-btn--flat v-btn--round theme--light" @click.prevent="subscribeEmailNotification">{{ $t('send') }}</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  import RepositoryFactory from '@/services/RepositoryFactory';
  const NotificationService = RepositoryFactory.get('notification');
  export default {
    name: 'schoolNotification',
    props: ['showNotification', 'province', 'schoolType', 'schoolName', 'schoolId'],
    data() {
      return {
        emailErrorMessage: null,
        emailNotification: '',
      }
    },
    methods: {
      subscribeEmailNotification() {
        let email = this.emailNotification;
        if (!this.emailIsValid(email)) {
          this.emailErrorMessage = this.$t("invalid_email_format");
          return;
        }

        NotificationService.subscribeEmail(this.emailNotification, this.province, this.schoolType, this.schoolName, this.schoolId);

        this.emailNotification = '';
        this.closeDialog();
      },
      emailIsValid (email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      },
      closeDialog() {
        this.$emit('sendCloseDialog', false);
      }
    }
  }
</script>
